import axiosInstance from '@/api/axiosInstance';
import type { WidgetInstance, WidgetInstanceCreate, WidgetInstanceUpdate } from '@/components/widgets/types';

const BASE = '/v1/widgets';

export const WidgetsApi = {
  async getByPage(pageKey: string): Promise<WidgetInstance[]> {
    const res = await axiosInstance.get(`${BASE}/`, { params: { page_key: pageKey } });
    return res.data ?? [];
  },

  async create(data: WidgetInstanceCreate): Promise<WidgetInstance> {
    const res = await axiosInstance.post(`${BASE}/`, data);
    return res.data;
  },

  async update(id: number, data: WidgetInstanceUpdate): Promise<WidgetInstance> {
    const res = await axiosInstance.put(`${BASE}/${id}`, data);
    return res.data;
  },

  async remove(id: number): Promise<void> {
    await axiosInstance.delete(`${BASE}/${id}`);
  },

  async reorder(pageKey: string, orderedIds: number[]): Promise<void> {
    await axiosInstance.put(`${BASE}/reorder`, { page_key: pageKey, ordered_ids: orderedIds });
  },

  /** Widget types switched off for the tenant (Widget Management) — readable by every signed-in user */
  async disabledTypes(): Promise<string[]> {
    const res = await axiosInstance.get(`${BASE}/disabled-types`);
    return res.data ?? [];
  },

  /** Get all widget instances across all pages (admin) */
  async getAll(): Promise<WidgetInstance[]> {
    const res = await axiosInstance.get(`${BASE}/all`);
    return res.data ?? [];
  },
};
